import type { TellescopeModelFromName } from "@tellescope/tanstack-query";
import { HIDDEN_ANSWER_TYPES } from "./constants";
import { renderAnswer } from "./render-answer";

type Answer = NonNullable<TellescopeModelFromName<"form_responses">["responses"]>[number]["answer"];

export interface FormAnswerProps {
  title: string;
  answer: Answer;
}

export const FormAnswer = ({ title, answer }: FormAnswerProps) => {
  if (HIDDEN_ANSWER_TYPES.includes(answer.type)) return null;

  return (
    <div className="border-b border-gray-100 pb-3 last:border-b-0 print:break-inside-avoid w-full">
      <div className="text-sm font-medium text-gray-700 mb-1">{title}</div>
      <div className="text-sm text-gray-900">{renderAnswer(answer)}</div>
    </div>
  );
};
